/** Anzeigename einer Unterhaltung: Person oder Gruppentitel, nie das Wort „Chat“. */

export function personName(person) {
  return String(person?.full_name || person?.username || '').trim();
}

export function otherParticipants(conv, meId) {
  const self = meId || conv?.current_user_id;
  return (conv?.participants || []).filter((p) => String(p.id) !== String(self));
}

export function isGroupConversation(conv) {
  return conv?.kind === 'group' || (conv?.participants || []).length > 2;
}

export function conversationListTitle(conv, meId) {
  if (isGroupConversation(conv)) {
    const title = String(conv?.title || '').trim();
    if (title) return title;
    const names = otherParticipants(conv, meId).map(personName).filter(Boolean);
    return names.join(', ') || 'Gruppe';
  }
  const other = otherParticipants(conv, meId)[0];
  return personName(other) || String(conv?.title || '').trim() || 'Unbekannt';
}

export function conversationHeaderTitle(conv, meId) {
  return conversationListTitle(conv, meId);
}

const ROLE_LABEL = {
  teacher: 'Lehrkraft',
  student: 'Schüler',
  guardian: 'Eltern',
  admin: 'Verwaltung',
};

export function indexContactsByUser(contacts) {
  const byUser = {};
  (contacts || []).forEach((contact) => {
    if (!contact?.user_id) return;
    const prev = byUser[contact.user_id];
    const score = (contact.subjects || []).length;
    const prevScore = prev ? (prev.subjects || []).length : -1;
    if (!prev || score > prevScore) byUser[contact.user_id] = contact;
  });
  return byUser;
}

export function personContext(contact) {
  if (!contact) return '';
  const role = ROLE_LABEL[contact.person_type] || '';
  const subjects = (contact.subjects || []).map((s) => String(s).trim()).filter(Boolean);
  return [subjects.join(', '), role].filter(Boolean).join(' · ');
}

export function conversationContext(conv, byUser = {}) {
  if (isGroupConversation(conv)) {
    const count = (conv?.participants || []).length;
    return count ? `${count} Teilnehmer` : '';
  }
  const other = otherParticipants(conv)[0];
  if (!other) return '';
  return personContext(byUser[other.id] || byUser[String(other.id)]);
}
